import Header from "./Header";
import Footer from "./Footer";

function Layout({ children, username, onSignOut }) {
  return (
    <div className="flex flex-col min-h-screen">
      <Header username={username} onSignOut={onSignOut} />

      <main className="flex-grow">
        {children}
      </main>

      <Footer />
    </div>
  );
}

export default Layout;
